// Terraço: deck de madeira com jardim de grama nos dois cantos de baixo. Dois guarda-sóis
// com espreguiçadeiras, uma fonte no centro e um banco à direita. O elevador fica na parede
// do alto e a escada, embaixo.

import type { RoomMap, Spot } from '../../core/world.js';

// Espreguiçadeiras: quem deita fica de costas para a borda de baixo, olhando para o céu (cima).
const SUN_SPOTS: readonly Spot[] = [
  { id: 'terraco:sol-0', x: 2, y: 5, facing: 'up', kind: 'sofa', use: 'rest' },
  { id: 'terraco:sol-1', x: 3, y: 5, facing: 'up', kind: 'sofa', use: 'rest' },
  { id: 'terraco:sol-2', x: 9, y: 5, facing: 'up', kind: 'sofa', use: 'rest' },
  { id: 'terraco:sol-3', x: 10, y: 5, facing: 'up', kind: 'sofa', use: 'rest' },
];

export const TERRACO: RoomMap = {
  id: 'terraco',
  kind: 'terrace',
  name: 'Terraço',
  // d = deck, g = grama (jardim dos cantos de baixo)
  floor: [
    'dddddddddddddddd',
    'dddddddddddddddd',
    'dddddddddddddddd',
    'dddddddddddddddd',
    'dddddddddddddddd',
    'dddddddddddddddd',
    'dddddddddddddddd',
    'dddddddddddddddd',
    'ggggddddddddgggg',
    'ggggddddddddgggg',
  ],
  legend: { d: 'deck', g: 'grama' },
  items: [
    // parede norte: elevador, quadro de avisos, calendário e relógio
    { item: 'quadro-avisos', x: 3, y: 0 },
    { item: 'elevador', x: 6, y: 0 },
    { item: 'calendario', x: 10, y: 0 },
    { item: 'relogio', x: 13, y: 0 },
    // cantos de cima: plantas grandes e um poste de rua
    { item: 'planta-grande', x: 0, y: 1 },
    { item: 'vaso-alto', x: 15, y: 1 },
    { item: 'poste', x: 0, y: 6 },
    // guarda-sóis e espreguiçadeiras (nb: pode ficar em cima do deck)
    { item: 'guarda-sol', x: 2, y: 2 },
    { item: 'guarda-sol', x: 9, y: 2 },
    { item: 'espreguicadeira', x: 2, y: 5 },
    { item: 'espreguicadeira', x: 3, y: 5 },
    { item: 'espreguicadeira', x: 9, y: 5 },
    { item: 'espreguicadeira', x: 10, y: 5 },
    // centro: fonte, canteiro de flores e banco de praça com vista
    { item: 'fonte', x: 6, y: 4 },
    { item: 'canteiro-flores', x: 4, y: 7 },
    { item: 'banco-praca', x: 12, y: 6 },
    // jardim de baixo: arbusto e lixeira de rua
    { item: 'arbusto', x: 14, y: 9 },
    { item: 'lixeira-rua', x: 1, y: 9 },
  ],
  doors: [{ x: 7, y: 9 }],
  spots: SUN_SPOTS,
};
